module.exports = __webpack_public_path__ + "static/faq_bg-ee3d8de91bb4c4ecdd7613dc01c90cab.jpg";